import { exampleData } from "./feature-page";

export const researchData = exampleData;
